import axios from "axios";

const findTypeElements = async (id) => {
  const token = localStorage.getItem("token");

  const result = await axios.get(
    `${process.env.REACT_APP_URL_BACKEND}api/v1/type-elements?id=${id}`,
    {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
      },
    }
  );
  const data = await result.data;
  return data;
};

export default findTypeElements;
